import { i18n } from 'next-i18next';
import localeHelpers from './localeHelpers';

function buildTagNames(tags) {
  const dataLanguage = localeHelpers.convertToDataLanguage(i18n.language);
  const tagNames = tags
    ?.map((tag) => {
      let tagName = '';
      try {
        const names =
          typeof tag.name === 'object' ? tag.name : JSON.parse(tag.name);
        tagName = names[`name_${dataLanguage}`] || names[`name_original`];
      } catch (error) {
        tagName = '';
      }
      return tagName;
    })
    .filter((tagName) => tagName)
    .slice(0, 3);
  return tagNames?.join(', ');
}

function parseTemplates(items) {
  return items.map((item) => {
    let itemTitle;
    try {
      const titleByLanguages = JSON.parse(item.title);
      itemTitle =
        titleByLanguages.title_original || titleByLanguages.title_jp || '';
    } catch (e) {
      itemTitle = '';
    }

    let catName;
    try {
      catName = JSON.parse(item.category.name);
    } catch (e) {
      catName = item.category.name || '';
    }

    return {
      id: item.id,
      title: itemTitle,
      height: item.height,
      width: item.width,
      thumbnail_url: item.thumbnail_url || '',
      workarea_unit: item.workarea_unit || '',
      num_pages: item.num_pages || '',
      category: {
        id: item.category.id || '',
        cat_slug: item.category.cat_slug || '',
        name: catName || '',
      },
      tags: item.tags.map((tag) => {
        let tagName;
        try {
          tagName = JSON.parse(tag.name);
        } catch (e) {
          tagName = tag.name || '';
        }
        return {
          id: tag.id,
          name: tagName,
        };
      }),
    };
  });
}

export default { buildTagNames, parseTemplates };
